import { jsx as _jsx } from "react/jsx-runtime";
import { useValidationContext } from '../../../../../../context/validationContext';
import { useSwapDataState } from '../../../../../../context/swap';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { ErrorDisplay } from './ErrorDisplay';
import FailIcon from '../../../../../../components/Icons/FailIcon';
import ErrorDismissButton from './ErrorDismissButton';
const ValidationError = ({ showSwapErrors = false }) => {
    const { routeValidation } = useValidationContext();
    const { swapError: _swapError, depositActionsError, setSwapError } = useSwapDataState();
    const { values } = useFormikContext();
    const swapError = showSwapErrors ? _swapError : null;
    useEffect(() => {
        if (swapError)
            setSwapError?.(null);
    }, [showSwapErrors, values.from?.name, values.to?.name, values.fromAsset?.symbol, values.toAsset?.symbol, values.amount, values.fromExchange?.name, values.destination_address]);
    if (routeValidation.message) {
        return (_jsx("div", { className: "mt-2", children: _jsx(ErrorDisplay, { icon: routeValidation.details.icon, title: routeValidation.details.title, message: routeValidation.message }) }));
    }
    if (swapError) {
        return (_jsx("div", { className: "mt-2", children: _jsx(ErrorDisplay, { icon: _jsx(FailIcon, { width: 20, height: 20 }), title: "Couldn't create swap", message: swapError, action: setSwapError ? _jsx(ErrorDismissButton, { onClick: () => setSwapError(null) }) : undefined }) }));
    }
    if (showSwapErrors && depositActionsError) {
        return (_jsx("div", { className: "mt-2", children: _jsx(ErrorDisplay, { icon: _jsx(FailIcon, { width: 20, height: 20 }), title: "Couldn't generate deposit address", message: depositActionsError }) }));
    }
    return null;
};
export default ValidationError;
